/**
 * Inline form error. role=alert + aria-live=polite ensures screen
 * readers announce the error when it appears.
 */
export function ErrorMessage({
  children,
  requestId,
}: {
  children: React.ReactNode;
  requestId?: string | undefined;
}) {
  return (
    <div
      role="alert"
      aria-live="polite"
      className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-700 dark:bg-red-950/40 dark:text-red-300"
    >
      <p>{children}</p>
      {requestId && (
        <p className="mt-1 text-xs text-red-600/70 dark:text-red-400/70">
          Reference: {requestId}
        </p>
      )}
    </div>
  );
}
